import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { leadMagicApi } from '@/lib/api';

export function useLeadMagicStatus() {
  return useQuery({
    queryKey: ['leadmagic-status'],
    queryFn: () => leadMagicApi.getStatus(),
  });
}

export function useLeadMagicConnect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (apiKey: string) => leadMagicApi.connect(apiKey),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['leadmagic-status'] });
    },
  });
}

export function useLeadMagicDisconnect() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => leadMagicApi.disconnect(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['leadmagic-status'] });
    },
  });
}
